import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';

const AdminGuard = () => {
  const { user } = useAuthStore();
  const location = useLocation();

  if (!user?.roles?.includes("ROLE_ADMIN")) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }
  return <Outlet />;
};

export default AdminGuard;
